import type { IModuleSummary } from '@platform/core/types';

/**
 * Типи записів, які прототип v4 вважає модулями простору (ws.modules: головні й дочірні таблиці окремо): типи встановлених модулів
 * каталогу простору з позицією `order` у переліку модулів простору. Встановлені модулі без жодної позиції (можливості платформи —
 * календар, зв'язки, теги; база знань і CRM у нових і демо-просторах) прототип у ws.modules не має — їх тут немає. Каталог без позицій
 * узагалі (без простору, старіший сервер) — усі типи встановлених модулів. Модуль, не встановлений чи вимкнений у просторі, не дає
 * жодного. Чиста функція.
 */
export function workspaceTypeKeys(modules: readonly Pick<IModuleSummary, 'installed' | 'recordTypes'>[]): ReadonlySet<string> {
  const installed = modules.filter((m) => m.installed !== false);
  const ordered = installed.some((m) => m.recordTypes.some((r) => typeof r.order === 'number'));
  const keys = new Set<string>();
  for (const m of installed) for (const r of m.recordTypes) if (!ordered || typeof r.order === 'number') keys.add(r.key);
  return keys;
}
